define(["require", "exports", "tslib", "vue"], function (require, exports, tslib_1, vue_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DirectivesAutoFocus = void 0;
    vue_1 = (0, tslib_1.__importDefault)(vue_1);
    var DirectivesAutoFocus = (function (_super) {
        (0, tslib_1.__extends)(DirectivesAutoFocus, _super);
        function DirectivesAutoFocus() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        DirectivesAutoFocus.prototype.bind = function (el, binding, vnode) {
            var innerHTML = "\n\t\t\tname: ".concat(JSON.stringify(binding.name), "\n\t\t\tvalue:\n\t\t\t").concat(JSON.stringify(binding.value), "\n\t\t\texpression:\n\t\t\t").concat(JSON.stringify(binding.expression), "\n\t\t\t'argument: '\n\t\t\t").concat(JSON.stringify(binding.arg), "\n\t\t\tmodifiers:\n\t\t\t").concat(JSON.stringify(binding.modifiers), "\n\t\t\tvnode keys:\n\t\t\t").concat(Object.keys(vnode).join(', '));
            console.log(innerHTML);
        };
        DirectivesAutoFocus.prototype.inserted = function (el, binding, vnode, oldVnode) {
            console.log('start focus monitor');
            if (el) {
                el.focus();
            }
        };
        return DirectivesAutoFocus;
    }(vue_1.default));
    exports.DirectivesAutoFocus = DirectivesAutoFocus;
});
//# sourceMappingURL=DirectivesAutoFocus.js.map